import { FormattedMessage } from 'react-intl';
import { useFilter } from '@synergy/components';

import { Customer } from '../../models/customer';
import { PoolCustomerAutocompleteList } from '../../autocomplete-list/customer-autocomplete-list/pool-customer-autocomplete-list';

export const CustomerFilter = () => {
    const { filter, getFromCache, updateCache, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (customer: Customer | null) => {
        filter.delete('customerAccountId');
        if (customer) {
            updateCache(`customer_${customer.id}`, customer?.name);
            filter.set('customerAccountId', customer.id.toString());
        }
        updateFilter(filter);
    };

    const getDisplayValue = (customerId: unknown): string => {
        if (typeof customerId !== 'string') {
            return '';
        }

        return getFromCache(`customer_${customerId}`) as string;
    };

    registerFilterMap('customerAccountId', getDisplayValue);

    return (
        <PoolCustomerAutocompleteList
            onSelected={onSelected}
            label={<FormattedMessage id="app.filter.customer" />}
            required={false}
            initialValue={getDisplayValue(filter.get('customerAccountId')) ?? ''}
            disablePreventOverflow={true}
        />
    );
};
